// extracted by mini-css-extract-plugin
module.exports = {"button":"i_BM","label":"i_BN","icon":"i_BO","major":"i_BP","minor":"i_BQ","negative":"i_BR","destructive":"i_BS","special":"i_BT","diminished":"i_BU"};